import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2c7b83bf&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2c7b83bf&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7b83bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c7b83bf')) {
      api.createRecord('2c7b83bf', component.options)
    } else {
      api.reload('2c7b83bf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2c7b83bf&scoped=true", function () {
      api.rerender('2c7b83bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/facilityHome/index.vue"
export default component.exports